<template>
  <div>
    <div>
      <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
    </div>

    <div>
      <v-form ref="form">
        <v-container>
          <v-layout wrap>
            <v-flex md2 sm12>
              <v-select item-text="text" item-value="value" :items="typeItems" v-model="selected_type"
                :label='$t("passengersPage.type")'></v-select>
            </v-flex>
            <v-flex md2 sm12>
              <v-select item-text="text" item-value="value" :items="filterByItems" v-model="selected_filter_by"
                :label='$t("passengersPage.filterBy")'></v-select>
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Day'">
              <choose-date clearable :label='$t("passengersPage.from")' v-model="from"></choose-date>
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Day'">
              <choose-date clearable :label='$t("passengersPage.to")' v-model="to"></choose-date>
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Month'">
              <date-picker-multiple v-model="selected_month" />
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Year'">
              <v-select :items="years" v-model="selected_year" :label='$t("passengersPage.selectYear")'></v-select>
            </v-flex>
            <!--<v-flex md2 sm12>
              <v-btn color="primary" dark class="mb-2 cbtn" @click="getData(true)" :loading="loading">Export
                PDF</v-btn>
            </v-flex>-->
          </v-layout>
        </v-container>
      </v-form>
    </div>
    <div>
      <h2 style="margin-inline-start: 20px;">{{ $t("passengersPage.bookingsStats") }}</h2>
      <div class="options">
        <div v-for="(stat, index) in bookingsStats"
          v-if="!['static_constraints', 'captain_cancellation_reason', 'user_cancellation_reason'].includes(index)"
          :key="index" class="option">
          <div class="title">
            <span class="option-name">{{ statLabel(index) }}</span>
          </div>
          <div class="percentage">{{ stat || 0 }}</div>
        </div>
      </div>
      <h2 style="margin-inline-start: 20px;">{{ $t("passengersPage.paymentsStats") }}</h2>
      <div class="options">
        <div v-for="(stat, index) in paymentsStats"
          v-if="!['static_constraints', 'captain_cancellation_reason', 'user_cancellation_reason'].includes(index)"
          :key="index" class="option">
          <div class="title">
            <span class="option-name">{{ statLabel(index) }}</span>
          </div>
          <div class="percentage">{{ stat || 0 }}</div>
        </div>
      </div>
      <h2 style="margin-inline-start: 20px;">{{ $t("passengersPage.topCountries") }}</h2>
      <div class="options">
        <div v-for="(stat, index) in topCountries"
          v-if="!['static_constraints', 'captain_cancellation_reason', 'user_cancellation_reason'].includes(index)"
          :key="index" class="option">
          <div class="title">
            <span class="option-name">{{ statLabel(index) }}</span>
          </div>
          <div class="percentage">{{ stat || 0 }}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<style lang="scss"></style>

<script>
import ChooseDate from "@/components/monaco/input/ChooseDate";
import { companyNow } from "@/util/companyTime";
import DatePickerMultiple from "@/components/monaco/input/DatePickerMultiple";

export default {
  name: "CustomerAppStats",
  title: "passengersPage.statsTitle",
  components: { ChooseDate, DatePickerMultiple },
  data() {
    return {
      selected_type: "All",
      from: null,
      to: null,
      selectedYear: null,
      selected_filter_by: "Day",
      selected_day: null,
      selected_month: null,
      selected_year: null,
      custom_month: null,
      custom_year: null,
      selected_type: "All",
      reservation: true,
      instant: true,
      loading: false,
      years: [],
      bookingsStats: [],
      paymentsStats: [],
      topCountries: []
    };
  },

  computed: {
    typeItems() {
      return [
        { text: this.$t("passengersPage.all"), value: "All" },
        { text: this.$t("passengersPage.reservation"), value: "Reservation" },
        { text: this.$t("passengersPage.instant"), value: "Instant" },
      ];
    },
    filterByItems() {
      return [
        { text: this.$t("passengersPage.day"), value: "Day" },
        { text: this.$t("passengersPage.month"), value: "Month" },
        { text: this.$t("passengersPage.year"), value: "Year" },
      ];
    },
    statLabels() {
      return {
        all_completed_orders: this.$t("passengersPage.stats.allCompletedOrders"),
        customer_app_total_orders: this.$t("passengersPage.stats.customerAppTotalOrders"),
        customer_app_completed_orders: this.$t("passengersPage.stats.customerAppCompletedOrders"),
        customer_app_cancelled_orders: this.$t("passengersPage.stats.customerAppCancelledOrders"),
        orders_per_customer: this.$t("passengersPage.stats.ordersPerCustomer"),
        number_of_different_customers: this.$t("passengersPage.stats.numberOfDifferentCustomers"),
        orders_paid_inside: this.$t("passengersPage.stats.ordersPaidInside"),
        orders_paid_outside: this.$t("passengersPage.stats.ordersPaidOutside"),
        total_paid_amount: this.$t("passengersPage.stats.totalPaidAmount"),
        total_tip_amount: this.$t("passengersPage.stats.totalTipAmount"),
        total_cancellation_amount: this.$t("passengersPage.stats.totalCancellationAmount"),
        total_payment_fee_amount: this.$t("passengersPage.stats.totalPaymentFeeAmount"),
        average_amount_per_order: this.$t("passengersPage.stats.averageAmountPerOrder"),
        average_tips_per_order: this.$t("passengersPage.stats.averageTipsPerOrder"),
        difference: this.$t("passengersPage.stats.difference"),
      };
    },
  },
  watch: {
    selected_month(val) {
      (this.from = moment(val).startOf("month").format("YYYY-MM-DD")),
        (this.to = moment(val).endOf("month").format("YYYY-MM-DD")),
        this.getData(false);
    },
    selected_year(val) {
      (this.from = moment(val, "YYYY").startOf("year").format("YYYY-MM-DD")),
        (this.to = moment(val, "YYYY").endOf("year").format("YYYY-MM-DD")),
        this.getData(false);
    },
    selected_day(val) {
      // console.log(val);
      this.from = moment(val).format("YYYY-MM-DD");
      this.to = moment(val).format("YYYY-MM-DD");
      this.getData(false);
    },
    from(val) {
      if (this.selected_filter_by == "Day" && val != null && this.to != null) {
        this.getData(false);
      }
    },
    to(val) {
      if (this.selected_filter_by == "Day" && val != null && this.from != null) {
        if (this.from == null) this.from = this.to;
        this.getData(false);
      }
    },
    selected_type(val) {
      // console.log(val);
      this.reservation = true;
      this.instant = true;
      if (val == "Reservation") this.instant = false;
      else if (val == "Instant") this.reservation = false;
      this.getData(false);
    },
  },
  mounted() {
    const currentYear = new Date().getFullYear();
    this.years = Array.from({ length: 100 }, (v, i) => currentYear - i);
    this.selected_day = companyNow().format("YYYY-MM-DD");
    this.from = this.selected_day;
    this.to = this.selected_day;
  },
  methods: {
    statLabel(index) {
      return (
        this.statLabels[index] ||
        index.replace("___", "'").replaceAll("_", " ")
      );
    },
    getData(pdf) {
      this.loading = true;
      const params = new URLSearchParams();
      params.append("from", this.from);
      params.append("to", this.to);
      params.append("reservation", this.reservation ? 1 : 0);
      params.append("instant", this.instant ? 1 : 0);
      params.append("pdf", pdf ? 1 : 0);
      this.axios
        .get("customer_app_report", {
          responseType: pdf ? "blob" : "json",
          params: params,
        })
        .then((res) => {

          if (pdf == false) {
            this.bookingsStats = res.data.data.bookingsStats;
            this.paymentsStats = res.data.data.paymentsStats;
            this.topCountries = res.data.data.topCountries;

            let orders_paid_inside = this.bookingsStats.orders_paid_inside;
            let customer_app_completed_orders = this.bookingsStats.customer_app_completed_orders;


            this.bookingsStats.customer_app_completed_orders = this.addPercentage(this.bookingsStats.customer_app_completed_orders, this.bookingsStats.all_completed_orders)
            this.bookingsStats.customer_app_cancelled_orders = this.addPercentage(this.bookingsStats.customer_app_cancelled_orders, this.bookingsStats.customer_app_total_orders)

            this.bookingsStats.orders_per_customer = (this.bookingsStats.number_of_different_customers ? (customer_app_completed_orders / this.bookingsStats.number_of_different_customers) : 0).toFixed(2);

            this.bookingsStats.orders_paid_outside = this.addPercentage(this.bookingsStats.orders_paid_outside, customer_app_completed_orders)
            this.bookingsStats.orders_paid_inside = this.addPercentage(this.bookingsStats.orders_paid_inside, customer_app_completed_orders)

            // Compute money-derived values from RAW stored amounts first, then format for DISPLAY (÷100).
            // orders_paid_inside is a COUNT (divisor) -> never scaled. money / count = money.
            let average_amount_per_order = orders_paid_inside ? (this.paymentsStats.total_paid_amount / orders_paid_inside) : 0;
            let average_tips_per_order = orders_paid_inside ? (this.paymentsStats.total_tip_amount / orders_paid_inside) : 0;
            let difference = this.paymentsStats.total_tip_amount + this.paymentsStats.total_cancellation_amount - this.paymentsStats.total_payment_fee_amount;

            this.paymentsStats.average_amount_per_order = this.formatMoney(average_amount_per_order);
            this.paymentsStats.average_tips_per_order = this.formatMoney(average_tips_per_order);
            // Preserve the "+" sign on positive difference; format the money magnitude (÷100).
            this.paymentsStats.difference = difference > 0 ? "+" + this.formatMoney(difference) : this.formatMoney(difference);

            // Format the raw money totals for DISPLAY last (after they were used in the derivations above).
            this.paymentsStats.total_paid_amount = this.formatMoney(this.paymentsStats.total_paid_amount);
            this.paymentsStats.total_tip_amount = this.formatMoney(this.paymentsStats.total_tip_amount);
            this.paymentsStats.total_cancellation_amount = this.formatMoney(this.paymentsStats.total_cancellation_amount);
            this.paymentsStats.total_payment_fee_amount = this.formatMoney(this.paymentsStats.total_payment_fee_amount);


          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "CustomerAppReport.pdf");
            document.body.appendChild(link);
            link.click();
          }
          this.loading = false;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err, "red");
          this.loading = false;
        });
    },
    addPercentage(val1, val2) {
      let percentage = (val2 ? (val1 * 100 / val2) : 0).toFixed(2);
      return val1 + "(" + percentage + "%)"

    }
  }



};
</script>
<style lang="scss" scoped>
.options {
  width: 100%;
  float: inline-start;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 2.5em;
  gap: 16px;

  // gap: 16px;
  .option {
    float: inline-start;
    border: 1px solid #788e98;
    border-radius: 12px;
    overflow: hidden;
    min-width: 120px;

    .title {
      width: 100%;
      background: #ced3d4;
      padding: 12px 18px;
      float: inline-start;
      color: #202731;
      font-size: 12pt !important;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 1px;

      .count {
        color: rgb(197, 203, 204);
        font-size: 8pt;
        padding: 4px;
        border-radius: 4px;
        background: rgb(97, 127, 133);
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 85%;
        min-width: 24px;
        height: 24px;
      }
    }

    .percentage {
      width: 100%;
      padding: 0 12px;
      font-size: 18pt;
      color: #202731;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-weight: 700;

      .symbol {
        color: #788e98;
        font-size: 12pt;
        font-weight: 400;
        margin-inline-start: 4px;
      }
    }
  }
}
</style>
